import { DefaultTheme } from 'styled-components';

const size = {
  mobileS: '320px',
  mobileM: '376px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

interface ITheme extends DefaultTheme {
  colors: {
    [x: string]: string;
  };
  breakpoints: {
    [x: string]: string;
  };
  typeSize: {
    [x: string]: string;
  };
  spacing: {
    [x: string]: string;
  };
}

const theme: ITheme = {
  breakpoints: {
    mobileS: `(max-width: ${size.mobileS})`,
    mobileM: `(max-width: ${size.mobileM})`,
    mobileL: `(max-width: ${size.mobileL})`,
    tablet: `(max-width: ${size.tablet})`,
    tabletLandscape: `(max-height: ${size.tablet})`,
    laptop: `(max-width: ${size.laptop})`,
    laptopL: `(max-width: ${size.laptopL})`,
    desktop: `(max-width: ${size.desktop})`,
    desktopL: `(max-width: ${size.desktop})`,
  },
  typeSize: {
    xxs: '10px',
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '22px',
  },
  spacing: {
    xxs: '4px',
    xs: '8px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '40px',
    xxl: '64px',
  },
  colors: {
    black: '#000000',
    primaryGreen900: '#003720',
    primaryGreen800: '#005C35',
    primaryGreen700: '#00814B',
    primaryGreen600: '#00A660',
    primaryGreen500: '#00B86B',
    primaryGreen400: '#19BF7A',
    primaryGreen300: '#4CCD97',
    primaryGreen200: '#80DCB5',
    primaryGreen100: '#B2EAD3',
    primaryGreen50: '#E5F8F0',
    gray950: '#1C2631',
    gray900: '#253343',
    gray800: '#30445B',
    gray700: '#445A74',
    gray600: '#57728E',
    gray500: '#6783A0',
    gray400: '#7B93AF',
    gray300: '#92A7C1',
    gray200: '#AEC1DA',
    gray100: '#D0DDEC',
    gray50: '#E9EDF5',
    gray25: '#F5F7FA',
    gray15: '#F8F9FC',
    gray0: '#FFFFFF',
    blueCrayola900: '#17244A',
    blueCrayola800: '#273C7B',
    blueCrayola700: '#3655AC',
    blueCrayola600: '#456DDD',
    blueCrayola500: '#4D79F6',
    blueCrayola400: '#5F86F7',
    blueCrayola300: '#82A1F9',
    blueCrayola200: '#A6BCFA',
    blueCrayola100: '#CAD7FC',
    blueCrayola50: '#EDF2FE',
    green900: '#023C2A',
    green800: '#036347',
    green700: '#048B63',
    green600: '#05B37F',
    green500: '#06C78D',
    green400: '#1FCD98',
    green300: '#51D8AF',
    green200: '#82E3C6',
    green100: '#B4EEDD',
    green50: '#E6F9F4',
    red900: '#4D1620',
    red800: '#802434',
    red700: '#B3324A',
    red600: '#E6415E',
    red500: '#FF4869',
    red400: '#FF5A78',
    red300: '#FF7F96',
    red200: '#FFA3B4',
    red100: '#FFC8D2',
    red50: '#FFEDF0',
    orange900: '#4B2717',
    orange800: '#7D4126',
    orange700: '#AF5B35',
    orange600: '#E17544',
    orange500: '#FA824C',
    orange400: '#FB8E5E',
    orange300: '#FCA782',
    orange200: '#FDC0A6',
    orange100: '#FED9C9',
    orange50: '#FFF2ED',
    purple900: '#140127',
    purple800: '#220140',
    purple700: '#30025A',
    purple600: '#3D0374',
    purple500: '#440381',
    purple400: '#571C8E',
    purple300: '#7C4FA7',
    purple200: '#A281C0',
    purple100: '#C7B3D9',
    purple50: '#ECE6F2',
    coral900: '#4D1F20',
    coral800: '#803435',
    coral700: '#B3494B',
    coral600: '#E65E60',
    coral500: '#FF686B',
    coral400: '#FF777A',
    coral300: '#FF9597',
    coral200: '#FFB3B5',
    coral100: '#FFD2D3',
    coral50: '#FFF0F0',
    bluePurple900: '#2C2F4C',
    bluePurple800: '#494F7F',
    bluePurple700: '#666EB2',
    bluePurple600: '#838DE5',
    bluePurple500: '#929DFE',
    bluePurple400: '#9DA7FE',
    bluePurple300: '#B3BAFE',
    bluePurple200: '#C8CEFF',
    bluePurple100: '#DEE2FF',
    bluePurple50: '#F4F5FF',
    yellowOrange900: '#4D2E06',
    yellowOrange800: '#804D0A',
    yellowOrange700: '#B36B0E',
    yellowOrange600: '#E68A12',
    yellowOrange500: '#FF9914',
    yellowOrange400: '#FFA32B',
    yellowOrange300: '#FFB85A',
    yellowOrange200: '#FFCC89',
    yellowOrange100: '#FFE0B8',
    yellowOrange50: '#FFF5E7',
    navyBlue900: '#00172E',
    navyBlue800: '#00274C',
    navyBlue700: '#00376A',
    navyBlue600: '#004689',
    navyBlue500: '#004E98',
    navyBlue400: '#1960A2',
    navyBlue300: '#4C83B7',
    navyBlue200: '#80A7CC',
    navyBlue100: '#B2CAE0',
    navyBlue50: '#E5EDF5',
    blue900: '#04353F',
    blue800: '#075869',
    blue700: '#0A7C93',
    blue600: '#0D9FBD',
    blue500: '#0EB1D2',
    blue400: '#26B9D6',
    blue300: '#56C8DF',
    blue200: '#86D8E8',
    blue100: '#B7E8F1',
    blue50: '#E7F7FA',
  },
};

export { theme };
